<template>
	<button
		class="flex flex-row hover:bg-primary-500/10 items-center rounded py-2 px-2 text-center font-sans text-xs font-bold hover:text-success-500 transition-all bg-success text-white"
		@click="handlePrint"
	>
		<i class="tabler:printer w-5 h-5"></i>
	</button>
</template>

<script setup lang="ts">
import { messages } from '@/assets/language';
import { useAppStore } from '@/stores/app-store'

const { currentLng } = useAppStore()

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const handlePrint = () => {
	window.print();
};
</script>
<style>
@media print {
	.no-print {
		display: none;
	}
	.page-break-inside {
		page-break-inside: avoid; /* Evitoni ndarjen e faqeve brenda këtij elementi */
	}
	.sm\:w-4\/12,
	.md\:w-4\/12,
	.lg\:w-4\/12,
	.sm\:w-8\/12,
	.md\:w-8\/12,
	.lg\:w-8\/12 {
		width: 100% !important;
	}
	.md\:w-100\% {
		width: 80% !important;
	}
}
</style>
